import React from "react";
import apiClient from "../utils/ApiClient";

export const Addroutine = async (data) => {
    try {
        const response = await apiClient.post(`/api/add-update-routine`, data);
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const getEventMasterList = async () => {
    try {
        const response = await apiClient.get(`/api/event-master-list`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const getCountEntry = async () => {
    try {
        const response = await apiClient.get(`/api/count-entry`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const getAllEvents = async () => {
    try {
        const response = await apiClient.get(`/api/all-events`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const getAllEventsDetail = async (eventId, status) => {
    try {
        const response = await apiClient.get(`/api/event-details?event_id=${eventId}&status=${status}&stream=1`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};


export const Addmssage = async (data) => {
    try {
        const response = await apiClient.post(`/api/add-message`, data);
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const deleteRoutine = async (id) => {
    try {
        const response = await apiClient.get(`/api/destroy-event-schedule-details?event_schedule_id=${id}`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const getEditRoutine = async (eventId) => {
    try {
        const response = await apiClient.get(`/api/edit-event-schedule-details?event_schedule_id=${eventId}`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const updateLogistics = async (data) => {
    try {
        const response = await apiClient.post(`/api/update-logistic-status`,data)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};


export const OrderListUpdate = async (data) => {
    try {
        const response = await apiClient.post(`/api/order-list-update`,data)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};



export const ImportRoutine = async (data) => {
    try {
        const response = await apiClient.post(`/api/import-schedule`, data);
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};